<ng-container *ngIf="fileData">
    <twc-search (cleared)="clearSearch()">
        <input class="twc-nofocus" twcSearchInput [twcTooltip]="'OBJECT_BROWSER.SEARCH_TOOLTIP' | translate"
            placement="bottom" [placeholder]="'TAB_LAYERS.FILTER_LABEL' | translate" [(ngModel)]="searchText">
    </twc-search>
    <twc-tree [isCheckbox]="true">
        <twc-tree-item *ngFor="let project of getVisibleProjects(projects)" [isExpanded]="isExpanded(project)"
            (isExpandedChange)="onExpandedChange(project, $event)">
            <cw-text-highlight [text]="project.name" [selectedText]="searchText"></cw-text-highlight>
            <twc-tree-item *ngFor="let scan of getVisibleScans(project.scans, project)" [state]="isChecked(scan)"
                (stateChange)="onCheckedChange(scan, $event)">
                <cw-text-highlight [text]="scan.name" [selectedText]="searchText"></cw-text-highlight>
            </twc-tree-item>
        </twc-tree-item>
    </twc-tree>

</ng-container>